<template>
  <div class="cause-contain">
    <div class="title">{{title}}：</div>
    <div class="content">
      <div
        class="list line_bottom"
        v-for="(item,index) in caseList"
        :key="index"
        @click="checkFile(item.fileUrl,item.fileName)"
      >
        <div class="edge">
          <div class="pic">
            <img
              v-if="item.fileType=='pdf' || item.fileType == 'application/pdf'"
              src="../../../../assets/appraise/ic_pdf.png"
            />
            <img
              v-if="item.fileType=='doc'   || item.fileType == 'application/doc' "
              src="../../../../assets/appraise/ic_doc.png"
            />
            <img
              v-if="item.fileType=='exl' || item.fileType == 'application/exl'"
              src="../../../../assets/appraise/ic_exl.png"
            />
          </div>
          <div class="text">{{item.fileName}}.{{item.fileType}}</div>
          <div class="size">{{ item.fileSize}}</div>
        </div>
      </div>
    </div>
    <modalIframe :url="iframeurl"></modalIframe>
  </div>
</template>

<script>
import modalIframe from './modalIframe';
export default {
  name: "materialScience",
  components:{ modalIframe },
  props: {
    caseList: { type: Array },
    title: { type: String },
  },
  data() {
    return {
      // maxWidth: '24px'
      iframeurl:''
    };
  },
  methods: {
    checkFile(url, name) {
      //  this.iframeurl = url;
      const _this = this;
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓---测试隐藏的iframe--进来这里url:", url);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
        // this.$router.push({ path: "/appraise/iframepdf", query: { url: url } });
        this.iframeurl = url;
      } else {
        console.log('---ios的url:', url);
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: url,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1,
          },
          (cb) => {
            console.log(cb, "callback");
          }
        );
      }
      setTimeout( ()=>{
        _this.iframeurl = ''
      }, 100)
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.cause-contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    // color: rgba(51, 51, 51, 1);
    color: #999999;
    line-height: 20px;
    // 12 + 链接的 8个像素
    margin-top: 12px;
  }
  .content {
    margin-top: 12px;
    // background: rgba(255, 255, 255, 1);
    // box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    // border-radius:3px;
    .list {
      // border-bottom: solid 1px #EEEEEE;
      .edge {
        // padding:16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text {
          flex: 1;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 24px;
          color: rgba(51, 51, 51, 1);
          // text-overflow: -o-ellipsis-lastline;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // line-clamp: 2;
          word-break: break-all;
          -webkit-box-orient: vertical;
          padding-right: 32px;
          margin-left: 12px;
        }
        .pic {
          width: 34px;
          height: 38px;
        }
        .size {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
    }
    .line_bottom:last-child::after {
      background: none;
    }
    .line_bottom:first-child::after {
      background: none;
    }
    .line_bottom {
      margin-bottom: 16px;
    }
  }
}
</style>
